







import { defineComponent } from '@vue/composition-api';
import RecycleBin from '@/renderer/components/RecycleBin/components/RecycleBin.vue';
export default defineComponent({
  components: {
    RecycleBin,
  },
  setup() {
    return {};
  },
});
